import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import UserProp from '../propTypes/userProp';
import { displayUserName } from '../../services/utilityFunctions';

const UserBannerCard = props => {
  const { label, user } = props;
  const image = useMemo(() => {
    let img = '/images/no_user.png';
    if (user?.image?.thumb) {
      img = user.image.thumb;
    }
    return img;
  }, [user.image]);
  const name = displayUserName(user);
  return (
    <div className="user-card-banner-container">
      {label?.length > 0 && <div className="label">{`${label}:`}</div>}
      <div className="image-container">
        <img src={image} alt="user" />
      </div>
      <div className="name">{name}</div>
    </div>
  );
};

UserBannerCard.propTypes = {
  user: PropTypes.shape(UserProp.propType).isRequired,
  label: PropTypes.string,
};
UserBannerCard.defaultProps = {
  label: '',
};

export default UserBannerCard;
